import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56364756"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-12 flex-container" }
const _hoisted_2 = {
  class: "tw-bg-white tw-w-[630px] tw-rounded-[6px] box-shadow-contain tw-px-[20px] sm:tw-px-[55px] sm:tw-pt-[62.66px] tw-pb-[55.45px] lg:tw-pl-[70px] lg:tw-pr-[55px] tw-z-[1] contain-responsive",
  "data-cy": "vendor-assessment-external-sorry-modal"
}
const _hoisted_3 = { class: "tw-w-[405px] tw-text-[#0345BD] tw-text-[26px] tw-font-semibold tw-mb-[24px] title-responsive" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[15px] tw-font-normal tw-leading-[145%] content-responsive" }
const _hoisted_5 = { class: "tw-w-full tw-flex tw-justify-end tw-mt-[28px]" }

import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import VendorBasicPage from "./vendorBasicPage.vue";
import { onBeforeUnmount, ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentsExternalSorry',
  setup(__props) {

const orgName = ref(router.currentRoute.value.query);

const close = () => {
  window.location.href = "https://cybersystem.io/";
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

onBeforeUnmount(() => {
  beforeUnmount();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VendorBasicPage, {
    "main-class": "overflow-x-hide overflow-y-hide",
    "body-class": "tw-flex tw-items-center tw-justify-center tw-h-[100%]"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern2, {
          page: "LOGIN",
          "class-name": "automation"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-vendor-assessment-external-sorry-modal-title-1",
          )), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
            "app-vendor-assessment-external-sorry-modal-text-1",
          )), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "tw-w-[108px] tw-h-[45px] tw-bg-[#0345BD] tw-border-[#0345BD] btn btn-primary letsgo-button tw-rounded-[30px] box-shafow-button tw-text-center tw-text-[18px] tw-font-semibold button-responsive",
            tabindex: "3",
            onClick: close
          }, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-recommendations-action-table-bulk-actions-modal-button-add-no-action-1",
            ).toUpperCase()), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})